<template>
  <v-app>
    <v-content>
      <v-container id='top_section' fluid>
        <eventtop />
      </v-container>

      <v-container class='sections' fluid>
        <eventinfo />
      </v-container>

      <v-container class='sections' fluid>
        <eventguests />
      </v-container>

      <v-container class='sections' fluid>
        <eventtimeline />
      </v-container>

      <v-container class='sections' fluid>
        <eventmap />
      </v-container>

      <v-container class='sections' fluid>
        <eventother />
      </v-container>

      <v-container id='footer_section' fluid>
        <eventfooter />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import eventtop from './components/top'
import eventinfo from './components/info'
import eventguests from './components/guests'
import eventtimeline from './components/timeline'
import eventmap from './components/map'
import eventother from './components/other'
import eventfooter from './components/footer'

export default {
  name: 'App',
  components: {
    eventtop,
    eventinfo,
    eventguests,
    eventtimeline,
    eventmap,
    eventother,
    eventfooter
  }
}
</script>

<style>
  /** Global Settings */
  @import url('https://fonts.googleapis.com/css?family=Sarala:700|Kosugi');
  html,
  body,
  application {
    font-family: 'Sarala', 'Kosugi', sans-serif;
    color: rgb(52, 52, 52);
    font-size: 14px;
  }

  .font_caption {
    font-size: 0.8rem;
    color: rgb(135, 135, 135);
  }

  h1, h2, h3, h4 {
    font-family: 'Sarala', 'Kosugi', sans-serif;
  }

  .sections h2 {
    color: rgb(222, 0, 27);
    text-align: center;
    letter-spacing: 0.2rem;
  }
  .sections h2:before {
    display: inline-block;
    height: 5rem;
    width: 1px;
    transform: skew(-20deg);
      -webkit-transform: skew(-20deg);
      -moz-transform: skew(-20deg);
      -o-transform: skew(-20deg);
    background-color: rgb(222, 0, 27);
    content: '';
    vertical-align: middle;
    margin-right: 3rem;
  }
  .sections h2 a {
    color: inherit;
    text-decoration: none;
  }



  .sections .caution {
    background-color: rgb(255, 229, 228);
    padding: 3rem;
  }

  .sections .caution_title {
    color: rgb(222, 0, 27);
    font-weight: bold;
  }

  .sections .caution_message {
    margin-top: 1rem;
  }

  .sections .caution_message a {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }

  hr {
    margin: 2rem 0rem;
  }
</style>

<style scoped>

  #top_section {
    background-color: rgb(222, 0, 27);
    color: white;
    padding: 0px;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1) inset;
  }

  #footer_section {
    background-color: rgb(222, 0, 27);
  }

  .sections {
    padding: 1rem 0.5rem;
  }

  .sections:nth-child(odd) {
    background-color: rgb(241, 241, 241);
  }

  .sections:nth-child(even) {
    background-color: rgb(249, 249, 249);
  }

  .sections > * {
    width: 700px;
  }
</style>